import { nsDfs } from "@qdabra/forms-shared/xmlNamespaces";
import { dataFieldsPath, standardNamespaces } from "../../dataConnections/dataConnection.utils";
import { parseXmlNative } from "../../utility/xmlHelpers";
import { nsAdoDfs } from "../constants.namespaces";

const parseXML = parseXmlNative;

const baseXml = `<dfs:myFields xmlns:dfs="${nsDfs}" />`;

const namespaceOptions = { namespaces: standardNamespaces };

function getBaseXmlNode() {
    const dom = parseXML(baseXml);

    const dataFields = dom.createElementNS(nsDfs, "dataFields");

    dom.documentElement.appendChild(dataFields);

    return dom;
}

const makeXPathOptions = (context) => ({
    context,
    ...namespaceOptions,
});

function adoAdapter(adapter, template, xpathEngine, dataSources, dataSourceName, api) {

    var commandText = adapter.commandText;
    var nodeName = null;

    function makeXmlItem(nodeName, valueItem, dom) {
        var el = dom.createElementNS(nsAdoDfs, "d:" + nodeName);

        for (const [key, value] of Object.entries(valueItem)) {
            el.setAttribute(key, value);
        }

        return el;
    }

    // (DOMDocument, any) -> [DOMNode]
    function qfsListToXml(dom, data) {
        var elementName = data.NodeName || nodeName;

        return data.Data.map((item) => makeXmlItem(elementName, item, dom));
    }

    async function executeQueryAsync(ds, options) {
        var detectName = (options && options.detectName) || false;
        var parameters = (options && options.parameters) || [];

        const data = await api.executeAdoAdapterAsync(adapter.connectionString, commandText, detectName, parameters);

        if (!(data && data.Success)) {
            throw new Error(data.Error || '(Unknown error)');
        }

        // The ds parameter passed into this method does not provide a good way of getting at the 
        // dataSourceNode wrapper for it
        var dataSource = dataSources.getDom(dataSourceName);

        var childNodes = qfsListToXml(dataSource.getNode(), data);
        var dataFields = dataSource.selectSingle(dataFieldsPath, namespaceOptions);

        return dataFields.setContentAsync(childNodes);
    }

    function getDsRootFromSamples(sampleDom) {
        if (adapter.isMainQuery) {
            return sampleDom;
        }

        var dcXPath = "/*/xd:DataConnection";

        return xpathEngine
            .evaluateXPath(dcXPath, makeXPathOptions(sampleDom))
            .toUnsortedArray()
            .find((node) => node.getAttribute("Name") === adapter.name);
    }

    async function determineNodeName() {
        const file = await template.getTemplateFileAsync('sampledata.xml');

        var sampleDom = parseXML(file);

        var dataNode = getDsRootFromSamples(sampleDom);

        if (!dataNode) {
            return;
        }

        var dfXPath = `local-name(${dataFieldsPath}/*)`;

        return xpathEngine
            .evaluateXPath(dfXPath, makeXPathOptions(dataNode))
            .stringValue();
    }

    async function initAsync(dataSource) {
        // Main Queries are populated elsewhere from template.xml
        if (!adapter.isMainQuery) {
            dataSource.setDom(getBaseXmlNode());
        }

        const foundNodeName = await determineNodeName();

        if (foundNodeName) {
            nodeName = foundNodeName;
        } else {
            console.warn("Could not determine result node name for adapter " + adapter.name);
        }
    }

    function getCommandText() {
        return commandText;
    }

    function setCommandText(commandString) {
        commandText = commandString;
    }

    async function submitAsync() {
        throw new Error("Submitting to database data connections is not currently supported.");
    }

    return {
        executeAsync: submitAsync,
        executeQueryAsync,
        initAsync,
        getCommandText,
        setCommandText,
        isAdoSupported: true
    };
}

export default adoAdapter;